export default __webpack_public_path__ + "acd74b3e2421308260e423936cdfbee2.svg";